/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Calendar_LaterInputs */

const en_landing_calendar_later = /** @type {(inputs: Landing_Calendar_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Later days`)
};

const pl_landing_calendar_later = /** @type {(inputs: Landing_Calendar_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Późniejsze dni`)
};

/**
* | output |
* | --- |
* | "Later days" |
*
* @param {Landing_Calendar_LaterInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_calendar_later = /** @type {((inputs?: Landing_Calendar_LaterInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Calendar_LaterInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_calendar_later(inputs)
	return en_landing_calendar_later(inputs)
});